import { useState } from "react"
import { ResponsivePie } from "@nivo/pie"

// 한국식 숫자 포맷터
function formatKoreanNumber(value) {
  if (value >= 1e12) return (value / 1e12).toFixed(1).replace(/\.0$/, "") + "조"
  if (value >= 1e8) return (value / 1e8).toFixed(1).replace(/\.0$/, "") + "억"
  if (value >= 1e4) return (value / 1e4).toFixed(1).replace(/\.0$/, "") + "만"
  return value?.toString() ?? "0"
}

export default function NivoPieWithFilter({ data, title, donut=true, height=280 }) {
  const [selected, setSelected] = useState([])
  const [showButtons, setShowButtons] = useState(false)

  if (!data || !data.length) {
    return <p>No data available</p>
  }

  const companies = data.map((d) => d.id)

  const toggleCompany = (company) => {
    setSelected((prev) =>
      prev.includes(company)
        ? prev.filter((c) => c !== company)
        : [...prev, company]
    )
  }

  const filtered =
    selected.length > 0 ? data.filter((d) => selected.includes(d.id)) : data

  const total = filtered.reduce((sum, d) => sum + d.value, 0)

  return (
    <div className="w-full relative">
      {/* 제목 + 버튼 나란히 */}
      <div className="flex justify-between items-center mb-2">
        {title && <h3 className="text-base font-semibold">{title}</h3>}
        <button
          onClick={() => setShowButtons(!showButtons)}
          className="px-2 py-1 rounded-md border text-xs bg-gray-50 hover:bg-gray-100"
        >
          {showButtons ? "선택 ▲" : "선택 ▼"}
        </button>
      </div>

      {/* 버튼 영역 */}
      {showButtons && (
        <div className="flex flex-wrap gap-2 mb-4 justify-start max-h-32 overflow-y-auto p-2 border rounded-md bg-gray-50">
          {companies.map((company) => (
            <button
              key={company}
              onClick={() => toggleCompany(company)}
              className={`px-2 py-0.5 rounded-md border text-xs ${
                selected.includes(company)
                  ? "bg-blue-500 text-white border-blue-600"
                  : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
              }`}
            >
              {company}
            </button>
          ))}
          {selected.length > 0 && (
            <button
              onClick={() => setSelected([])}
              className="px-2 py-0.5 rounded-md border text-xs bg-red-100 text-red-600 border-red-300 hover:bg-red-200"
            >
              전체보기
            </button>
          )}
        </div>
      )}

      {/* 파이 차트 */}
      <div style={{ height: height, overflow: "visible" }}>
        <ResponsivePie
          data={filtered}
          margin={{ top: 30, right: 70, bottom: 70, left: 70 }}
          innerRadius={donut ? 0.6 : 0}
          padAngle={1}
          cornerRadius={3}
          activeOuterRadiusOffset={8}
          colors={{ scheme: "set3" }}
          borderWidth={1}
          borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor="#333333"
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLinkLabelsDiagonalLength={10}
          arcLinkLabelsStraightLength={5}
          arcLabelsSkipAngle={20}
          arcLabel={(d) => formatKoreanNumber(d.value)}
          arcLabelsTextColor={{ from: "color", modifiers: [["darker", 2]] }}
          layers={[
            "arcs",
            "arcLabels",
            "arcLinkLabels",
            "legends",
            ({ centerX, centerY, radius }) => (
              <text
                x={centerX}
                y={centerY}
                textAnchor="middle"
                dominantBaseline="central"
                style={{
                  fontSize: radius * 0.18,
                  fontWeight: "bold",
                  fill: "#333",
                }}
              >
                {formatKoreanNumber(total)}
              </text>
            ),
          ]}
        />
      </div>
    </div>
  )
}
